<template>
    <div class="flexcol-fill text-light" overflow="hidden">
        <f-api ref="api"/>
        <v-container fluid class="flexcol-fill" overflow="hidden">
            <div class="flexcol-fix">
                <div v-if="loadingEvents && firstLoad" class="text-center">
                    <v-progress-linear indeterminate/>
                </div>
                <v-alert v-if="error !== null" type="error" class="mt-2">
                    {{ error }}
                </v-alert>  
                <kc-calendar-select v-show="calendarId === null && !loadingEvents" v-model="calendarId" class="mt-2"/>
            </div>
            <v-container v-if="calendarId !== null && (!loadingEvents || !firstLoad)" fluid class="flexcol-fix pa-0">
                <v-row v-if="currentEvents.length == 0" class="ma-0 pb-5 border-light-darken-3 border-b-sm border-opacity-100">
                    <v-col class="text-center">
                        <div class="mb-1"><v-icon icon="mdi-check-circle-outline" size="3rem" color="success"/></div>
                        <span class="text-success">Aktuell muss keine Tonne rausgestellt werden.</span>
                    </v-col>
                </v-row>
                <v-row v-for="event in currentEvents" v-bind:key="event.date" align="center">
                    <v-col class="text-center">
                        <img v-if="event.summary.includes('grau')" src="../assets/tonne_grau.png" style="width: 128px; height: 128px;"/>
                        <img v-if="event.summary.includes('blau')" src="../assets/tonne_blau.png" style="width: 128px; height: 128px;"/>
                        <img v-if="event.summary.includes('gelb')" src="../assets/tonne_gelb.png" style="width: 128px; height: 128px;"/>
                        <img v-if="event.summary.includes('braun')" src="../assets/tonne_braun.png" style="width: 128px; height: 128px;"/>
                        <v-container fluid class="ma-0 text-white">
                            <v-row align="center">
                                <v-col cols="auto">
                                    <v-icon icon="mdi-alert-outline" size="3rem"/>
                                </v-col>
                                <v-col class="text-left">
                                    <div v-if="event.start.date == $dayjs().format('YYYY-MM-DD')" class="small">Heute wird abgeholt:</div>
                                    <div v-if="event.start.date == $dayjs().add(1, 'days').format('YYYY-MM-DD')" class="small">Morgen wird abgeholt:</div>
                                    <div class="text-l font-weight-bold">{{ cleanSummary(event.summary) }}</div>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <v-btn color="success" @click="confirm()"><v-icon icon="mdi-check"/> Ich habe die Tonne rausgestellt</v-btn>
                                </v-col>
                            </v-row>                            
                        </v-container>
                    </v-col>
                </v-row>                    
            </v-container>
            <v-container fluid class="flexcol-fill overflow-auto mt-0 pa-0" v-if="futureEvents.length > 0">
                <v-row v-for="event in futureEvents" v-bind:key="event.id" align="center" class="ma-0 pt-2 pb-2 border-light-darken-3 border-b-sm border-opacity-100">
                    <v-col cols="auto">
                        <img v-if="event.summary.includes('grau')" src="../assets/tonne_grau.png" style="width: 48px; height: 48px;"/>
                        <img v-else-if="event.summary.includes('blau')" src="../assets/tonne_blau.png" style="width: 48px; height: 48px;"/>
                        <img v-else-if="event.summary.includes('gelb')" src="../assets/tonne_gelb.png" style="width: 48px; height: 48px;"/>
                        <img v-else-if="event.summary.includes('braun')" src="../assets/tonne_braun.png" style="width: 48px; height: 48px;"/>
                        <div v-else style="width: 48px; height: 48px;"></div>
                    </v-col>
                    <v-col>
                        <div>{{ $dayjs(event.start.date).format('ddd DD.MM.YYYY') }}</div>
                        <div class="font-weight-bold">{{ cleanSummary( event.summary ) }}</div>
                    </v-col>
                </v-row>
            </v-container>
        </v-container>
        <div v-if="currentEventAlert === true && alertInterval !== null" class="alertmask">
            &nbsp;
        </div>        
        <div v-if="currentEventAlert === true && alertInterval !== null" class="nicole">
            <img src="@/assets/nicole.png" alt="Nicole schimpft"/>
            <div clas="bg-primary text-center">
                <v-btn class="mt-2" color="success" block @click="confirm()"><v-icon icon="mdi-check"/> Ja, ja - ich habe es ja gemacht!</v-btn>
            </div>
        </div>
        <audio ref="alertSound" style="display: none" id="alertSound" volume="1" src="../assets/nicole.mp3"/>
    </div>
</template>
<script>
import kcCalendarSelect from './calendar-select.vue';
export default {
    name: 'kc-disposal',
    components: {
        kcCalendarSelect
    },
    data() {
        return { 
            error: null,
            calendarId: null,
            loadingEvents: false,
            firstLoad: true,
            events: [],
            refreshInterval: null,
            alertInterval: null,
            lastRefresh: null,
            refreshCycle: 0,
            confirmedEventIds: []
        }
    },
    computed: {    
        currentEvents() {
            const vm = this;
            var today = vm.$dayjs();
            var tomorrow = vm.$dayjs().add(1, 'days')
            var yesterday = vm.$dayjs().add(-1, 'days')
            var currentHour = vm.$dayjs().hour();
            return vm.events.filter(x => !vm.confirmedEventIds.includes(x.id)
                                            && (x.start.date === today.format('YYYY-MM-DD')
                                                || (x.start.date === yesterday.format('YYYY-MM-DD') && currentHour <= 5)
                                                || (x.start.date === tomorrow.format('YYYY-MM-DD') && currentHour >= 15)));

        },
        currentEventAlert() {
            const vm = this;
            if (vm.refreshCycle < 2) return false;
            if (vm.currentEvents.length > 0) {
                let currentHour = vm.$dayjs().hour();
                if (currentHour >= 20) {
                    return true;
                }
            }
            return false;
        },
        futureEvents() {
            const vm = this;
            var events = vm.events.filter(x => !vm.currentEvents.includes(x));
            return events.slice(0, 6);
        },
        bgVariant(event) {
            if (event.summary.includes('gelb')) return "warning";
            return "dark";
        }
    },
    watch: {
        calendarId(v) {
            const vm = this;
            localStorage["disposalCalendarId"] = vm.calendarId;        
            if (v !== null) vm.init();
        },
        currentEventAlert(v) {
            const vm = this;   
            if (v === true) {
                vm.startAlert();
            } else {
                vm.stopAlert();
            }
        }
    },
    mounted() {
        const vm = this;
        vm.init();
    },
    methods: {
        async init() {
            const vm = this;
            if (localStorage["disposalCalendarId"] !== undefined && localStorage["disposalCalendarId"] !== null) {
                vm.calendarId = localStorage["disposalCalendarId"];
            }
            if (this.calendarId !== null) {
                await vm.loadEvents();
                vm.startRefresh();
            }
        },
        async loadEvents() {
            const vm = this;
            vm.error = null;        
            vm.loadingEvents = true;
            var startDate = vm.$dayjs().add(1, 'days').format('YYYY-MM-DD') + 'T00:00:00.000Z';
            var endDate = vm.$dayjs().add(360, 'days').format('YYYY-MM-DD') + 'T23:59:59.000Z';
            try {
                let payload = {
                    calendarId: vm.calendarId,
                    startDate: startDate,
                    endDate: endDate
                };
                vm.events = await vm.$refs.api.getAsync('calendar/' + vm.calendarId+ '/events?from=' + startDate + '&to=' + endDate, payload);
                vm.loadingEvents = false;
                vm.firstLoad = false;            
            } catch(err) {
                vm.loadingEvents = false;
                vm.firstLoad = false;
                vm.error = err;
            }
        },
        startRefresh() {
            const vm = this;
            if (vm.refreshInterval !== null) {
                vm.stopRefresh();
            }
            vm.refreshInterval = setInterval(async function() {
                vm.refreshCycle++;
                if (!vm.loadingEvents) {
                    await vm.loadEvents();
                    vm.lastRefresh = vm.$dayjs();
                }
            }, 30000);
        },
        stopRefresh() {
            const vm = this;
            if (vm.refreshInterval) {
                clearInterval(vm.refreshInterval);
            }
        },      
        cleanSummary(summary) {
            summary = summary.replace('//', '');
            summary = summary.replace('GEM', '');
            return summary;
        },
        confirm() {
            const vm = this;
            vm.currentEvents.forEach(event => {
                if (!vm.confirmedEventIds.includes(event.id)) {
                    vm.confirmedEventIds.push(event.id);
                    vm.stopAlert();
                }
            });
        },
        stopAlert() {
            const vm = this;
            if (vm.$refs.alertSound !== undefined) {
                vm.$refs.alertSound.currentTime = 0;
                vm.$refs.alertSound.pause();
            }
            if (vm.alertInterval !== null) {
                clearInterval(vm.alertInterval);
            }
            vm.alertInterval = null;
        },
        startAlert() {
            const vm = this;
            vm.$refs.alertSound.play();            
            vm.alertInterval = setInterval(function() {
                vm.$refs.alertSound.play();                     
            }, 3600000);
        }
    }
}
</script>
<style lang="scss" scoped>
    .alertmask {
        position: fixed;
        left: 0%;
        top: 0;
        width: 100%;
        height: 100%;
        padding: 0rem;
        margin: 0rem;
        z-index: 99998;
        background-color: #000000;
        opacity: 0.5;
    }
    .nicole {
        position: fixed;
        left: 50%;
        top: 50%;
        z-index: 99999;
        transform: translate(-50%, -50%);
    }
</style>